import * as angular from "angular";

export interface LoaderService {
  appLoading(): boolean;
  setAppLoading: (newValue: boolean) => void;
  loadingPromise<T>(promise: angular.IPromise<T>): void;
}

/**
 * @module loaderService
 * @file exposes functions to toggle the loading screens
 */
export default angular.module('aps.services.loader', [])
  .service('loaderService', loaderService)
  .name;

/**
 * @method loaderService
 * @description service implementation
 */
function loaderService(): LoaderService {
  'use strict';

  /**
   * @private
   * @property _appLoading - toggles the loading screen
   * @property _priming - toggles the splash screen
   */
  let _appLoading = false;

  /**
   * @method appLoading
   * @description gets the app loading value
   * @returns: {bool}
   */
  function appLoading() {
    return _appLoading;
  }

  /**
   * @method setAppLoading
   * @description sets the app loading value
   * @param {boolean} newValue
   *  value to set
   */
  function setAppLoading(newValue: boolean) {
    _appLoading = newValue;
  }

  function loadingPromise(promise: angular.IPromise<any>) {
    if (promise && angular.isFunction(promise.finally)) {
      setAppLoading(true);
      promise.finally(function() {
        setAppLoading(false);
      });
    }
  }

  /**
   * @description service contract
   */
  return {
    appLoading: appLoading,
    setAppLoading: setAppLoading,
    loadingPromise: loadingPromise
  };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/app/components/loader/loader.service.ts